export const CARRIER_LOGO_MAP: Record<string, string> = {
    FEDEX: 'https://s3-us-west-2.amazonaws.com/shipsy-public-assets/CARRIER-LOGOS/fedex.png',
    UPS: 'https://s3-us-west-2.amazonaws.com/shipsy-public-assets/CARRIER-LOGOS/ups.png',
    MARKEN: 'https://shipsy-public-assets.s3.amazonaws.com/generic/file-138e5320-6c1d-4fd1-af74-1f49ee91ef70.png',
    'DHL EXPRESS': 'https://s3-us-west-2.amazonaws.com/shipsy-public-assets/CARRIER-LOGOS/dhl.png',
    MNX: 'https://shipsy-public-assets.s3.amazonaws.com/generic/file-9b94cc78-251c-4dd6-b47e-1a70964c8ff4.png',
    SINO: 'https://shipsy-public-assets.s3.us-west-2.amazonaws.com/generic/3PL-logo-sino',
    'WORLD COURIER': 'https://shipsy-public-assets.s3.us-west-2.amazonaws.com/generic/3PL-logo-cencora',
};

export const getCarrierLogo = (carrierCode: string): string | null => {
    return CARRIER_LOGO_MAP[carrierCode?.toUpperCase()] || null;
};

export const DASHBOARD_STATUS_COLOR_MAP = {
    'In Transit': {
        backgroundColor: '#FEF9C3',
        textColor: '#8D5825',
    },
    Delivered: {
        backgroundColor: '#DCFCE8',
        textColor: '#136C38',
    },
    'In Process': {
        backgroundColor: '#DBEAFE',
        textColor: '#2540B7',
    },
    Cancelled: {
        backgroundColor: '#FFE2E3',
        textColor: '#9C100D',
    },
    All: {
        backgroundColor: '#F3F4F6',
        textColor: '#000000',
    },
} as const;

export const DASHBOARD_STATUS_GROUPS = {
    'In Process': [
        'softdata_upload',
        '__in_process',
        'softdata_update',
        '__packed',
        'pickup_scheduled',
        'out_for_pickup',
        'inscan_at_hub',
        'reachedathub',
        'pickup_awaited',
        'assigned_courier_partner',
        'handover_courier_partner',
        'not_picked_up',
    ],
    'In Transit': [
        'intransittohub',
        '__shipped',
        'accept',
        'pickup_completed',
        'outfordelivery',
        'delay_at_airport',
        'rescheduled',
        'on_hold',
        'rto_initiated',
        'rto_in_transit',
        'rto_attempted',
        'rto_outfordelivery',
        'handed_in_customs_clearance',
        'pending_custom',
        'customs_clearance_completed',
        'shipment_clear_successfully',
    ],
    Delivered: [
        'delivery_pod',
        'delivered',
    ],
    Cancelled: [
        'cancelled',
        'rto',
        'lost',
        'shipment_destroyed',
    ],
    All: [],
};

export const TIMELINE_STATUS_GROUPS = {
    'In Process': [
        'softdata_upload',
        '__in_process',
        'softdata_update',
        'pickup_awaited',
    ],
    Packed: [
        '__packed',
        'assigned_courier_partner',
        'handover_courier_partner',
    ],
    Collected: [
        '__shipped',
    ],
    'In Transit': [
        'intransittohub',
        'pickup_scheduled',
        'out_for_pickup',
        'not_picked_up',
        'inscan_at_hub',
        'reachedathub',
        'accept',
        'pickup_completed',
        'outfordelivery',
        'delay_at_airport',
        'rescheduled',
        'on_hold',
        'rto_initiated',
        'rto_in_transit',
        'rto_attempted',
        'rto_outfordelivery',
        'handed_in_customs_clearance',
        'pending_custom',
        'customs_clearance_completed',
        'shipment_clear_successfully',
    ],
    Delivered: [
        'delivery_pod',
        'delivered',
    ],
    Cancelled: [
        'cancelled',
        'rto',
        'lost',
        'shipment_destroyed',
    ],
};

export const TIMELINE_STATUS_ORDER = [
    'In Process',
    'Packed',
    'Collected',
    'In Transit',
    'Delivered',
    'Cancelled',
];
